import React from 'react'

function CustomFooter() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className='app-footer' style={{ direction: 'ltr' }}>
      <p>&copy; {currentYear} Toastmasters International. All rights reserved.</p>
    </footer>
  )
}

export default CustomFooter;